import { useEffect, useRef, useState } from 'react'

import Footer from '../CommonComponents/Footer'
import { useStore } from '../../store'
import CustomList from '../CommonComponents/CustomList';
import BackHeader from '../CommonComponents/BackHeader';
import api from '../../api/apiClient';
import { endpoints } from '../../api/endpoints';
import { DataType, SongDataType, SongType } from '../../types';
import { useLocation } from 'react-router-dom';

export default function Playlist() {
  const {store} = useStore();
  const [data, setData] = useState<DataType>(null);
  const [loading,setLoading] = useState(false);
  const [hasMore,setHasMore] = useState(true);
  const [page,setPage] = useState(1);
  const location = useLocation();
  const playlistId = location.state.playlistId;
  const playlistName = location.state.playlistName;
  const firstMounted = useRef(true);

  const dataApi = useRef("");
  
  const fetchData = async () => {
    if(page === 1) setLoading(true);
    let p = page;

    const result: any = await api.get(endpoints.playlist.getPlayListDetail + `?id=${playlistId}&current=${p}&limit=10`);
    dataApi.current = endpoints.playlist.getPlayListDetail + `?id=${playlistId}&current=${p + 1}&limit=30`;
    if(p === 1) setLoading(false);
    if(result.code === '200'){
      const d : SongDataType = result.data;
      setData((pre) => {
        let obj: any = {...pre};
        let arr : any;
        if(p > 1){
          if(pre && d) arr = [...pre?.by,...d?.by]
          obj.by = arr;
          return obj
        }else{
          return d
        }
      });
    }else{
      if(p > 1){
        setHasMore(false);
      }else{
        setData(null);
      }
    }
  }
  
  useEffect(() => {
    fetchData();
  },[page])

  useEffect(() => {
    if(firstMounted.current) return;
    if(data?.by?.length === data?.pagination?.total) setHasMore(false);
  },[data]);

  useEffect(()=> {
    if(firstMounted.current) firstMounted.current = false;
  },[]);

  const handleFetchMore = () => {
    setPage(pre => pre + 1)
  };

  return ( 
    <div>
      <div>
        <BackHeader/>
        <h1 style={{position: 'fixed', top: 0, left: "50%",transform: 'translate(-50%, 0)',color: "white", fontSize: "22px"}}>
          {playlistName}
        </h1>
      </div>
      <div style={{padding: "0 15px"}}>
          <CustomList
            data={data}
            type={'Song'}
            showFavorite
            loading={loading}
            handleFetchMore={handleFetchMore}
            hasMore={hasMore}
            scrollHeight={store.screenHeight - 60}
            dataApi={dataApi.current}
          />
      </div>
      <Footer/>
    </div>
  )
}
